import { delay, put, select, takeLatest } from "redux-saga/effects"
import { CreateCheckout, checkoutComplete, createCheckoutError, createCheckoutSuccess } from "./checkout";
import { PayloadAction } from "@reduxjs/toolkit";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { RootState } from "./store";
import { apiBaseUrl } from "./rootSaga";
import { AuthState } from "./auth";
import { DonationInfo, DonationState } from "./donation";

export const getAuthInfo = (state: RootState) : AuthState => state.AuthInfo;

type CreateCheckoutReq = {
    amountInCents: number,
    email?: string,
    name?: string,
    mobile?: string
}

type CreateCheckoutRes = {
    checkoutId: string | null,
    error: string | null
}

function* executeCreateCheckout(action: PayloadAction<DonationInfo>): any {
    try {
        const authState: AuthState = yield select(getAuthInfo);
        const apiRequest: CreateCheckoutReq = {
            amountInCents: action.payload.donationAmount! * 100,
            email: action.payload.email,
            mobile: action.payload.mobileNumber,
            name: action.payload.name
        };

        const checkoutResponse: AxiosResponse<CreateCheckoutRes> = yield axios.post(
            `${apiBaseUrl}/api/TerminalCheckouts`,
            apiRequest,
            {
                auth: {
                    username: authState.authInfo!.username,
                    password: authState.authInfo!.password
                }
            });
            
        if (checkoutResponse.data.error)
            yield put(createCheckoutError(`${apiBaseUrl}-${checkoutResponse.data.error}-${checkoutResponse.status}-${checkoutResponse.statusText}`));
        else
        {
            yield put(createCheckoutSuccess(checkoutResponse.data.checkoutId!));
            yield delay(7000);
            yield put(checkoutComplete());
        }

    } catch (error: any) {
        const errorMessage = `${apiBaseUrl}-${error.toString()}`;
        yield put(createCheckoutError(errorMessage));
    }
}

export function* watchCreateCheckout() {
    yield takeLatest(CreateCheckout, executeCreateCheckout);
}